import * as React from 'react';
import { cn } from '@/lib/utils';

export interface PaperStackArrowProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  alt?: string;
}

export const PaperStackArrow = React.forwardRef<HTMLImageElement, PaperStackArrowProps>(
  ({ alt = '', className, ...rest }, ref) => (
    <img
      ref={ref}
      src="/character-system/scribble/paper-stack-arrow-v1.png"
      alt={alt}
      className={cn('block h-auto w-full select-none', className)}
      draggable={false}
      {...rest}
    />
  ),
);
PaperStackArrow.displayName = 'PaperStackArrow';
